export const constants = {
    search: {
        defaultMapCenter: [139.766908, 35.680934],
        defaultZoom: 5,
    },
    detail: {
        defaultZoom: 7,
    },
};
